import React from "react";
import "./MyOrder.css";
import Breadcrumb_comp from "../Common-Component/Breadcrumb_comp/Breadcrumb_comp";
import My_order_card from "../Common-Component/My_order_card/My_order_card";
import { getAllOrder } from "../../features/order/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

function MyOrder() {
  const breadcrumbData = [
    { name: "Home", link: "/home" },
    { name: "Order" }, // No link for the last item (active)
  ];

  const order = useSelector((state) => state.order.allOrders);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllOrder());
  }, [dispatch]);

  
  return (
    <>
      <section className="MyOrder">
        <div className="custom_container">
          <div className="breadcrump_holder">
            <div className="Breadcrumb_div">
              <Breadcrumb_comp data={breadcrumbData} />
            </div>
          </div>

          <div className="my-order_card_container">
            {order?.data?.map((val) => (
              <My_order_card val={val} />
            ))}
            {/* <My_order_card />
            <My_order_card />
            <My_order_card />
            <My_order_card />
            <My_order_card /> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default MyOrder;
